// extracted by mini-css-extract-plugin
export default {"root":"DeleteConfirm_root__GHkgk","content":"DeleteConfirm_content__ZMlPs","info":"DeleteConfirm_info__mb76h","actions":"DeleteConfirm_actions__FNLyK"};